import * as ECSConstants from '../../ecs/constants';
import * as BlockSDK from '../../utilities/blockSdkHelper';

const script = `
%%[
/*
  Einstein Content Testing -- Modify At Your Own Risk
*/

VAR @subscriber_id, @subscriber_key, @mid, @mid_dash, @hash_subid, @hash_subkey
SET @subscriber_id = SubscriberID
SET @subscriber_key = lowercase(_subscriberkey)
SET @mid = memberid
SET @mid_dash = Concat(@mid, "-")
SET @hash_subid = SHA256(Concat(@mid_dash,@subscriber_id))
SET @hash_subkey = SHA256(Concat(@mid_dash,@subscriber_key))
]%%

`;

const endComment = `
%%[
/*
  Einstein Content Testing -- End
*/
]%%
`;

function querystring() {
  const map = {
    subscriberId: '%%=v(@hash_subid)=%%',
    subscriberKey: '%%=v(@hash_subkey)=%%',
    context: '%%_messagecontext%%',
    jobId: '%%jobid%%',
    batchId: '%%_JobSubscriberBatchID%%'
  };

  return Object.entries(map)
    .map(e => `${e[0]}=${e[1]}`)
    .join('&');
}

function generateExperimentBlockHtmlContent(experiment) {
  const base_url = window.location.host;
  const imagePath = `/einstein/api/experiment/${experiment.uuid}`;
  const urlPath = `/einstein/api/feedback/${experiment.uuid}`;
  const url = `https://${base_url}${urlPath}?${querystring()}`;
  const imageUrl = `https://${base_url}${imagePath}?${querystring()}`;
  const content = `<a href="${url}" alias="ECSlink_alias"><img src="${imageUrl}" width="100%" height="auto"></a>`;

  return `${script}${content}${endComment}`;
}

export function setExperimentContentInSdk(experiment, options = {}) {
  const contentElement = generateExperimentBlockHtmlContent(
    experiment,
    options
  );

  return dispatch => {
    dispatch({
      type: ECSConstants.REQUEST_SET_CONTENT,
      content: contentElement
    });

    return BlockSDK.setContent(contentElement).then(() => {
      dispatch({
        type: ECSConstants.RECEIVE_SET_CONTENT,
        content: contentElement
      });
    });
  };
}
